"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQiniuUploadToken = void 0;
var _axios = _interopRequireDefault(require("@/utils/axios"));
/*
 * @Description: 文件上传接口
 * @Author: yitong
 * @Date: 2021-12-08 10:30:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-18 10:01:24
 */

/**
 * FIXME: 目前该项目中没使用到直传七牛功能，故暂无开发以下两个接口，后续根据实际业务需要进行完善
 * 七牛云上传凭证获取接口（上传路径：前端->七牛云）
 * @returns {Promise<{
 * uploadToken: string;
 * domain: string
 * }>}
 * **返回**
 * - uploadToken 七牛云上传凭证
 * - domain 绑定域名
 */
const getQiniuUploadToken = () => _axios.default.get('/v1/qiniu/upload/token');
exports.getQiniuUploadToken = getQiniuUploadToken;